export const mockServices = [
  {
    id: 1,
    name: 'Mindful Life Coaching Session',
    title: 'Mindful Life Coaching Session',
    description: 'Begeleiding naar meer balans en focus.',
    category: 'coaching',
    price: 85,
    duration: 90,
    location: 'Amsterdam',
    images: ['https://images.pexels.com/photos/4056723/pexels-photo-4056723.jpeg?auto=compress&w=400&h=400&fit=crop'],
    status: 'Active',
    rating: 4.9,
    bookings: 90,
  },
  {
    id: 2,
    name: 'Breathwork & Meditation Circle',
    title: 'Breathwork & Meditation Circle',
    description: 'Samen ademen en tot rust komen.',
    category: 'workshop',
    price: 35,
    duration: 60,
    location: 'Online',
    images: ['https://images.pexels.com/photos/3822621/pexels-photo-3822621.jpeg?auto=compress&w=400&h=400&fit=crop'],
    status: 'Active',
    rating: 4.8,
    bookings: 15,
  },
  {
    id: 3,
    name: 'Chakra Alignment Session',
    title: 'Chakra Alignment Session',
    description: 'Herstel je energiecentra.',
    category: 'consulting',
    price: 75,
    duration: 75,
    location: 'Gent',
    images: ['https://images.pexels.com/photos/317155/pexels-photo-317155.jpeg?auto=compress&w=400&h=400&fit=crop'],
    status: 'Draft',
    rating: 4.7,
    bookings: 8,
  }
];